/**
 * A versao que o servidor roda (ADR-007). Se a aba ficou aberta durante um deploy, a tela e antiga e a API ja e nova:
 * campo que a API passou a pedir nem aparece, e o erro so chega no fim (Eduarda, 17/09). Entao a tela avisa e oferece
 * atualizar. Sem `VERSAO` no config (dev), nunca avisa.
 */
import { useQuery } from "@tanstack/react-query";
import { config } from "./config";

export function useVersaoDoServidor(): { desatualizada: boolean } {
  const daTela = config().VERSAO ?? "";
  const q = useQuery({
    queryKey: ["versao-do-servidor"],
    enabled: Boolean(daTela),
    refetchInterval: 120_000,
    refetchOnWindowFocus: true,
    retry: false,
    queryFn: async () => {
      const r = await fetch(`${config().API_URL.replace(/\/$/, "")}/health`);
      return (await r.json()) as { versao?: string };
    },
  });
  const doServidor = q.data?.versao ?? "";
  return { desatualizada: Boolean(daTela && doServidor && daTela !== doServidor) };
}
